const getImageQueryProps = (operations) => Object.keys(operations)
    .map((k) => `${k}_${operations[k]}`)
    .join(',');
// NOTE: Make sure that ImageWithLoader from composer still works if you change this.
export const adjustImage = (fileName, ops) => {
    if (fileName.startsWith('http')) {
        return fileName;
    }
    const operationsArray = Array.isArray(ops)
        ? [...ops]
        : [
            {
                type: 'fit',
                operations: ops,
            },
        ];
    const operationParts = operationsArray.map(({ type, operations }) => `/${type}/${getImageQueryProps(operations)}`);
    return `https://images.wixstatic.com/media/${fileName}/v1${operationParts.join('')}/${fileName}`;
};
//# sourceMappingURL=adjust-image.js.map